export function toNumber(value) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null
  }

  if (value == null || value === '' || value === '-') return null

  // Expected format:
  // 5.3542       -> 5.3542
  // 10,000,000   -> 10000000
  const number = Number(String(value).trim().replace(/,/g, ''))

  return Number.isFinite(number) ? number : null
}

export function normalizeText(value) {
  return String(value || '').trim().toUpperCase()
}

// Builds a per-row lookup of the "effective" FX spot: the row's own spotfx
// when present, otherwise the last valid spotfx seen for ANY prior row in
// the same array order. Must be built once from the FULL (unfiltered) row
// set so the forward-fill has a stable "donor" row regardless of which
// rows are currently filtered out.
export function createEffectiveSpotMap(rows) {
  const spotByRow = new WeakMap()
  let lastValidSpot = 0

  for (const row of rows) {
    const spot = toNumber(row.spotfx)

    if (spot != null && spot > 0) {
      lastValidSpot = spot
    }

    spotByRow.set(row, lastValidSpot)
  }

  return spotByRow
}

// Converts a row's notional to BRL using its effective spot (see
// createEffectiveSpotMap). BRL-denominated rows pass through unchanged.
export function convertNotionalToBRL(row, effectiveSpot) {
  const notional = toNumber(row.notional)

  if (notional == null) return null
  if (normalizeText(row.currency) === 'BRL') return notional

  return effectiveSpot ? notional * effectiveSpot : null
}
